var angular = require('angular');
var config = require('config');
require('./angular-locale_es-es.js');
require('angular-cookie')
require('c3-angular')
// require('./api');

require('../node_modules/c3/c3.min.css')

var myApp = angular.module('myApp', [
    require('angulartics'),
    require('angulartics-google-analytics'),
    require('ng-admin'),
    require('ng-token-auth')
]);

myApp.constant('endpoint', config['END_POINT']);

// I18n
myApp.config(['$translateProvider', require('./i18n/es.js')]);

// Directives
myApp.directive('acDateField', require('./fields/acDataField.js'));

// custom API flavor
var apiFlavor = require('./api_flavor');
require('./auth')(myApp);
// myApp.config(['RestangularProvider', apiFlavor.requestInterceptor]);
// myApp.config(['RestangularProvider', apiFlavor.responseInterceptor]);
myApp.config(['RestangularProvider', apiFlavor.errorInterceptor]);

myApp.run(['$rootScope', function($rootScope) {
    $rootScope.appName = config.APP_NAME;
    $rootScope.endPoint = config.END_POINT;
}])

// custom 'amount' type
// myApp.config(['NgAdminConfigurationProvider', 'FieldViewConfigurationProvider', function(nga, fvp) {
//     nga.registerFieldType('amount', require('./types/AmountField'));
//     fvp.registerFieldView('amount', require('./types/AmountFieldView'));
// }]);

myApp.config(['NgAdminConfigurationProvider', 'FieldViewConfigurationProvider', function(nga, fvp) {
    nga.registerFieldType('time_of_day', require('./types/TimeOfDayField'));
    fvp.registerFieldView('time_of_day', require('./types/TimeOfDayFieldView'));
}]);

myApp.directive('maTimeOfDay', require('./types/maTimeOfDayField.js'));
myApp.directive('maTimeOfDayInput', require('./types/maTimeOfDayInputField.js'));

// custom directives
// myApp.directive('approveReview', require('./reviews/approveReview'));
// myApp.directive('batchApprove', require('./reviews/batchApprove'));
// myApp.directive('starRating', require('./reviews/starRating'));
// myApp.directive('basket', require('./commands/basket'));
myApp.directive('dashboardSummary', require('./dashboard/dashboardSummary'));
myApp.directive('versionChecker', require('./version/versionChecker'));
// myApp.directive('zoomInModal', require('./products/zoomInModal'));

// custom controllers
myApp.controller('username', ['$scope', '$window', '$auth', function($scope, $window, $auth) { // used in header.html
    $scope.user = $auth.user;
    $scope.logout = function() {
        $auth.signOut().finally(
            function(){
                $window.location.reload();
            });
    }
}])

// myApp.factory('Center', ['$resource', function($resource) {
//   return $resource(config.END_POINT + 'centers/:id');
// }]);
myApp.controller('center', ['$scope', 'Restangular', '$rootScope', '$window', '$state', function($scope, Restangular, $rootScope, $window, $state) { // used in header.html
    $scope.select = function(_center) {
        $scope.center = _center;
        $window.localStorage.setItem('center_id', _center.id);
        $state.reload();
    };

    Restangular.all('centers').getList()
        .then(function(response) {
            // FIXME: why does centers sometimes we have to use .data somethimes?
            var centers = response.data || response;
            $scope.centers = centers;
            var centerId = $window.localStorage.getItem('center_id');
            var center = _.find(centers, function(center) {
                return center.id == centerId;
            })
            $scope.center = center || $scope.centers[0];
            /*
             * FIXME: look for a posible alternative that would allow the
             * application to wait until the center_id is known before start
             * requesting resources from an unknown (null) center_id
             */
            if ($window.localStorage.getItem('center_id') == null) {
                $window.localStorage.setItem('center_id', $scope.center.id);
                $state.reload();
            }
        });
}]);

// custom states (pages)
require('./calendar/calendarResource.js')(myApp, config);
require('./stats/statsState.js')(myApp);

myApp.config(['$stateProvider', require('./calendar/calendarState.js')]);
myApp.config(['$stateProvider', require('./therapy/therapyState.js')]);
myApp.config(['$stateProvider', require('./help/helpState.js')]);

// myApp.config(['$stateProvider', require('./segments/segmentsState')]);

myApp.directive('fiEvent', require('./events/fiEvent.js'))

myApp.config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push(function() {
        return {
            request: function(config) {
                var isList = !/\d$/.test(config.url);
                var notNestedResources = !/\/\d+\/\w/.test(config.url);
                if (isList && !/\/auth\//.test(config.url) &&
                        !/\/centers$/.test(config.url) && notNestedResources) {
                    // TODO: Use a service that could notify users of center_id
                    var centerId = window.localStorage.getItem('center_id');
                    config.url = config.url.replace('api/', 'api/centers/' + centerId + '/');
                }
                return config;
            },
        };
    });
}]);

myApp.config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push(function() {
        return {
            request: function(config) {
                if (!config.params || !config.params.filters) {
                    return config;
                }

                if (/\/events$/.test(config.url) && config.params.filters.group_therapy_id) {
                    config.url = config.url.replace('events', 'group_therapies/' + config.params.filters.group_therapy_id + '/events');
                    // delete config.params.filters.group_therapy_id;
                }
                return config;
            },
        };
    });
}]);

myApp.config(['RestangularProvider', function (RestangularProvider) {
    RestangularProvider.addFullRequestInterceptor(function(element, operation, what, url, headers, params) {
        if (operation == "getList") {
            // custom pagination params
            if (params._page) {
                params.page = params._page;
                params.per_page = params._perPage;;
            }
            delete params._page;
            delete params._perPage;

            // custom sorting params
            if (params._sortField) {
                params.sort_by = params._sortField;
                params.direction = params._sortDir == 'DESC' ? 'desc' : 'asc';
            }
            delete params._sortField;
            delete params._sortDir;

            // custom filtering params
            if (params._filters) {
                params.filters = params._filters;
            }
            delete params._filters;
        }
        return { params: params };
    });

    RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response) {
        if (operation == "getList") {
            response.totalCount = response.headers('Total');
        }
        return data;
    });
}]);

myApp.config(['NgAdminConfigurationProvider', function (nga) {
    // create the admin application
    var admin = nga.application(config.APP_NAME)
        .baseApiUrl(config.END_POINT);
            // + '/centers/{centerId}/');

    // add entities
    admin.addEntity(nga.entity('users'));
    admin.addEntity(nga.entity('centers'));
    admin.addEntity(nga.entity('activities'));
    admin.addEntity(nga.entity('groups'));
    admin.addEntity(nga.entity('exercises'));
    admin.addEntity(nga.entity('parent_categories'));
    admin.addEntity(nga.entity('categories'));
    admin.addEntity(nga.entity('properties'));
    admin.addEntity(nga.entity('values'));
    admin.addEntity(nga.entity('cognitive_functions'));
    admin.addEntity(nga.entity('periodic_events'));
    admin.addEntity(nga.entity('group_therapies'));
    admin.addEntity(nga.entity('events'));
    admin.addEntity(nga.entity('evaluations'));
    admin.addEntity(nga.entity('evaluations_grouped'));
    // admin.addEntity(nga.entity('products'));
    // admin.addEntity(nga.entity('reviews'));
    // admin.addEntity(nga.entity('commands'));
    // admin.addEntity(nga.entity('settings'));

    // configure entities
    require('./users/config')(nga, admin);
    require('./centers/config')(nga, admin);
    var groups = require('./groups/config')(nga, admin);
    var cfs = require('./cognitive_functions/config')(nga, admin);
    var activities = require('./activities/config')(nga, admin);
    var categories = require('./categories/config')(nga, admin, activities);
    var properties = require('./properties/config')(nga, admin, activities);
    var values = require('./values/config')(nga, admin, properties, activities);
    var exercises = require('./exercises/config')(nga, admin, activities, categories, cfs);
    require('./periodic_events/config')(nga, admin, activities, groups);
    require('./group_therapies/config')(nga, admin, groups);

    // TODO: delete?
    require('./events/config')(nga, admin, activities);
    require('./evaluations/config')(nga, admin, activities, groups, exercises, properties, values);
    require('./evaluations_grouped/config')(nga, admin, activities, groups, exercises, properties, values);

    // require('./products/config')(nga, admin);
    // require('./reviews/config')(nga, admin);
    // require('./commands/config')(nga, admin);
    // require('./settings/config')(nga, admin);

    admin.dashboard(require('./dashboard/config')(nga, admin));
    admin.header(require('./header.html'));
    admin.menu(require('./menu')(nga, admin));

    // attach the admin application to the DOM and execute it
    nga.configure(admin);
}]);



// WEBPACK FOOTER //
// ./js/main.js